<div class="grid-x">
  <div class="cell small-12">
    <label>
      <span class="label-text required">Display as:</span>
      <select [(ngModel)]="currentQuestion.type" (ngModelChange)="onChange()">
        @for (qKind of questionKindKeys; track qKind) {
          <option [value]="qKind.value">{{qKind.name}}</option>
        }
      </select>
    </label>
  </div>
  <div class="cell small-12">
    <label>
      <span class="label-text">Label:</span>
    </label>
    <div [froalaEditor]="froalaOptions" [(ngModel)]="currentQuestion.label" (ngModelChange)="onChange()"></div>
  </div>
</div>
<div class="cell small-12">
  <ng-template dynamic-component-loader [componentName]="displayConfiguration" [componentData]="currentQuestion" isEdit="true"></ng-template>
</div>
<div class="cell small-12 padding-right-small minor-margin-top">
  <div class="checkbox">
    <label>
      <input class="show-for-sr" type="checkbox" id="chkReview" [(ngModel)]="enableReviewEditing" (ngModelChange)="onChange()" />
      <label aria-hidden="true" for="chkReview" class="inline">
        <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        <span class="control-label-text padding-left">Allow Editing in Review Form?</span>
      </label>
    </label>
  </div>
</div>
<div class="cell small-12 padding-right-small">
  <div class="checkbox">
    <label>
      <input class="show-for-sr" type="checkbox" id="chkRequireNotes" [(ngModel)]="requireNotes" (ngModelChange)="onChange()" />
      <label aria-hidden="true" for="chkRequireNotes" class="inline">
        <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        <span class="control-label-text padding-left">Require a Note before Editing? <help-text [helpText]="'Applies only to editing in the review form'"></help-text></span>
      </label>
    </label>
  </div>

</div>
<div class="cell small-12 margin-top">
  <label class="">
    <span class="label-text">Help Text:</span>
  </label>
  <div [froalaEditor]="froalaOptions" [(ngModel)]="currentQuestion.helpText" (ngModelChange)="onChange()"></div>
</div>